import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TEXT_FIELD_STATUS, CONTEXT_PROVIDERS, LOADING, ERROR, SUCCESS } from '../../../../utils/constants';
import URLTextField from '../../../../components/_molecules/URLTextField/URLTextField';
import Button from '../../../../components/_atomic/Button/Button';
import ErrorModal from '../../../../components/_molecules/ErrorModal/ErrorModal';
import LoadingOverlay from '../../../../components/_molecules/LoadingOverlay/LoadingOverlay';
import CreateAppFormContext from './CreateAppFormContext';
import RadioButtonGroup from '../../../../components/_molecules/RadioButtonGroup/RadioButtonGroup';
import ConnectedTextField from '../../../../components/_atomic/ConnectedTextField/ConnectedTextField';
import ToolTipWrapper from '../../../../components/_molecules/ToolTipWrapper/ToolTipWrapper';
import ImageInput from '../../../../components/_molecules/ImageInput/ImageInput';
import CheckBoxGroup from '../../../../components/_molecules/CheckBoxGroup/CheckBoxGroup';
import CopyValue from '../../../../components/_molecules/CopyValue/CopyValue';
import Questions from '../Questions/Questions';
import './Form.scss';
import InfoModal from '../../../../components/_molecules/InfoModal/InfoModal';
import SuccessModal from '../../../../components/_molecules/SuccessModal/SuccessModal';

/* eslint-disable */
const platformToolTips = {
  ADJUST: (
    <span>Adjust integration requires you to add Advaice as partner on Adjust.
    Please, give us access to the reporting for your application and your target events{' '}<a target="_blank" href="https://docs.adjust.com/en/special-partners/">(more info)</a>.
    </span>
  ),
  APPSFLYER: (
    <span>Appslfyer integration requires you to add Advaice as Integrated partner on Appsflyer.
    Please, give us access to the reporting for your application and your target events{' '}<a target="_blank" href="https://support.appsflyer.com/hc/en-us/articles/208643876-Agency-Permission">(more info)</a>.
    </span>),
};


/* eslint-enable */


const appsflyerLogo = require('../../assets/appsflyer.png');
const adjustLogo = require('../../assets/adjust.png');
const informLogo = require('../../assets/information.svg');

const linkExample = 'https://play.google.com/store/apps/details?id=com.spotify.music&hl=ru';
const appLinkURLFieldName = 'app-link';
const appNameTextFieldName = 'app-name';
const appImageInputName = 'app-image';
const platformsRadioName = 'platforms-radio';
const trackingLinkURLFieldName = 'tracking-link';
const targetToggleName = 'target-audience';
const appAnswersName = 'app-answers';

class CreateAppForm extends Component {
  static propTypes = {
    getAppQuestions: PropTypes.func.isRequired,
    annulError: PropTypes.func.isRequired,
    appImageError: PropTypes.string.isRequired,
    getAppImage: PropTypes.func.isRequired,
    appQuestions: PropTypes
      .shape({})
      .isRequired,
    appImage: PropTypes
      .shape({ title: PropTypes.string.isRequired })
      .isRequired,
    appImageStatus: PropTypes.string.isRequired,
    createApp: PropTypes.func.isRequired,
    createAppStatus: PropTypes.string.isRequired,
    createAppError: PropTypes.string.isRequired,
    currentApp: PropTypes.shape({}).isRequired,
    updateApp: PropTypes.func.isRequired,
    deleteAppSuccess: PropTypes.string.isRequired,
    deleteAppStatus: PropTypes.string.isRequired,
    deleteAppError: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool,
    deleteApplication: PropTypes.func.isRequired,
  };
  static defaultProps = {
    isAdmin: false,
  }

  constructor() {
    super();
    this.fields = {};
  }

  state = {
    formStatus: TEXT_FIELD_STATUS.INITIAL,
    searchAppLink: '',
    showDeleteModal: false,
    fields: {
      [appLinkURLFieldName]: {
        status: TEXT_FIELD_STATUS.INITIAL,
        isFocused: false,
        value: '',
        errorText: '',
        hint: '',
        outerError: false,
      },
      [appNameTextFieldName]: {
        status: TEXT_FIELD_STATUS.INITIAL,
        isFocused: false,
        value: '',
        errorText: '',
        hint: '',
        needValidator: false,
      },
      [appImageInputName]: {
        status: TEXT_FIELD_STATUS.INITIAL,
        isFocused: false,
        value: '',
        errorText: '',
        hint: '',
        needValidator: false,
      },
      [platformsRadioName]: {
        status: TEXT_FIELD_STATUS.INITIAL,
        value: '',
        errorText: '',
        hint: '',
      },
      [trackingLinkURLFieldName]: {
        status: TEXT_FIELD_STATUS.INITIAL,
        isFocused: false,
        value: '',
        errorText: '',
        hint: '',
        needValidator: false,
        // outerError: true,
      },
      [targetToggleName]: {
        status: TEXT_FIELD_STATUS.INITIAL,
        isFocused: false,
        value: [],
        errorText: '',
        hint: '',
        needValidator: false,
      },
      [appAnswersName]: {
        status: TEXT_FIELD_STATUS.INITIAL,
        value: {},
      },
    },
  }
  componentWillMount() {
    const { currentApp } = this.props;
    const fields = { ...this.state.fields };
    if (currentApp.id) {
      fields[appLinkURLFieldName].value = currentApp.link;
      fields[appLinkURLFieldName].disabled = true;
      fields[appNameTextFieldName].value = currentApp.name;
      fields[appImageInputName].value = currentApp.logo;
      fields[platformsRadioName].value = currentApp.tracker;
      fields[trackingLinkURLFieldName].value = currentApp.trackingLink;
      if (currentApp.answers) {
        currentApp.answers.forEach((answer) => {
          if (answer.answer) {
            fields[targetToggleName].value = ['audience'];
            fields[appAnswersName].value[answer.id] = answer.answer;
          }
        });
      }
      this.setState(() => ({ fields }));
    }
  }

  componentDidUpdate(prevProps) {
    const {
      appImage: newAppImage, appImageStatus, appImageError, currentApp, // deleteAppStatus,
    } = this.props;
    const { appImage: oldAppImage, appImageStatus: oldAppImageStatus } = prevProps;
    const fields = {
      ...this.state.fields,
    };
    if (newAppImage.img !== oldAppImage.img) {
      if (appImageStatus === SUCCESS) {
        fields[appNameTextFieldName].value = newAppImage.title;
        fields[appImageInputName].value = newAppImage.img;
        fields[appLinkURLFieldName].outerError = false;
        fields[appLinkURLFieldName].status = TEXT_FIELD_STATUS.VALID;

        if (fields[appNameTextFieldName].status !== TEXT_FIELD_STATUS.INITIAL) {
          const { validator } = this.fields[appNameTextFieldName];
          const validate = validator(fields[appNameTextFieldName].value);
          fields[appNameTextFieldName].status = validate.status;
          fields[appNameTextFieldName].errorText = validate.errorText;
        }
      }
      this.setState(() => ({ fields }));
    }

    if (appImageStatus !== oldAppImageStatus) {
      if (appImageStatus === ERROR) {
        fields[appNameTextFieldName].value = newAppImage.title;
        fields[appImageInputName].value = newAppImage.img;
        if (fields[appNameTextFieldName].status !== TEXT_FIELD_STATUS.INITIAL) {
          const { validator } = this.fields[appNameTextFieldName];
          const validate = validator(fields[appNameTextFieldName].value);
          fields[appNameTextFieldName].status = validate.status;
          fields[appNameTextFieldName].errorText = validate.errorText;
        }
        fields[appLinkURLFieldName].status = TEXT_FIELD_STATUS.INVALID;
        fields[appLinkURLFieldName].outerError = true;
        fields[appLinkURLFieldName].errorText = appImageError.indexOf('Bad link') > -1
          ? 'It\'s not an app link'
          : 'Try again please';
      }
      this.setState(() => ({ fields }));
    }

    if (currentApp.id && prevProps.currentApp.id !== currentApp.id) {
      fields[appLinkURLFieldName].value = currentApp.link;
      fields[appNameTextFieldName].value = currentApp.name;
      fields[appLinkURLFieldName].disabled = true;
      fields[appImageInputName].value = currentApp.logo;
      fields[platformsRadioName].value = currentApp.tracker;
      fields[trackingLinkURLFieldName].value = currentApp.trackingLink;
      if (currentApp.answers) {
        currentApp.answers.forEach((answer) => {
          if (answer.answer) {
            fields[targetToggleName].value = ['audience'];
            fields[appAnswersName].value[answer.id] = answer.answer;
          }
        });
      }
      this.setState(() => ({ fields }));
    }
    if (currentApp.id !== prevProps.currentApp.id && !currentApp.id) {
      fields[appLinkURLFieldName].value = '';
      fields[appNameTextFieldName].value = '';
      fields[appLinkURLFieldName].disabled = false;
      fields[appImageInputName].value = '';

      fields[platformsRadioName].value = '';
      fields[trackingLinkURLFieldName].value = '';
      fields[targetToggleName].value = [];
      fields[appAnswersName].value = {};
      this.setState(() => ({ fields }));
    }
  }
  getFormStatus = (fields) => {
    let status = TEXT_FIELD_STATUS.INITIAL;
    let validFields = 0;
    let invalidFields = 0;
    const fieldsNames = Object.keys(fields);
    /* calc invalid fields coz form can have one VALID and one INITIAL field
           then form isn't valid or invalid it is initial */
    fieldsNames.forEach((name) => {
      if (fields[name].status === TEXT_FIELD_STATUS.VALID) {
        validFields += 1;
      }
      if (fields[name].status === TEXT_FIELD_STATUS.INVALID) {
        invalidFields += 1;
      }
    });
    if (validFields === fieldsNames.length) {
      status = TEXT_FIELD_STATUS.VALID;
    }
    if (invalidFields > 0) {
      status = TEXT_FIELD_STATUS.INVALID;
    }
    return status;
  };

  getAppImage = (data) => {
    this.props.getAppImage(data);
  }

  registerField = ({ name, validator }) => {
    this.fields[name] = {
      validator,
    };
  };

  fieldChangeHandler = ({ name, value }) => {
    const fields = {
      ...this.state.fields,
    };
    let formStatus = {
      ...this.state.formStatus,
    };
    fields[name].value = value;
    if (fields[name].status !== TEXT_FIELD_STATUS.INITIAL && !fields[name].outerError) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }
    if (fields[platformsRadioName].value === 'ADJUST') {
      if (name === trackingLinkURLFieldName && (value === 'http://' || value === 'https://')) {
        fields[name].status = TEXT_FIELD_STATUS.VALID;
        fields[name].errorText = '';
      }
    } else {
      fields[name].status = TEXT_FIELD_STATUS.VALID;
      fields[name].errorText = '';
    }
    this.setState(() => ({ fields, formStatus }));
  };

  fieldFocusHandler = ({ name, isFocused }) => {
    const fields = {
      ...this.state.fields,
    };
    let { formStatus } = {
      ...this.state.formStatus,
    };
    let { searchAppLink } = this.state;

    fields[name].isFocused = isFocused;
    if (!isFocused) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      if (!fields[name].outerError) {
        fields[name].status = validate.status;
        fields[name].errorText = validate.errorText;
      }
      formStatus = this.getFormStatus(fields);
      const currentValue = fields[name].value;
      if (name === appLinkURLFieldName && searchAppLink
          !== currentValue && (validate.status === TEXT_FIELD_STATUS.VALID ||
              fields[appLinkURLFieldName].outerError) && currentValue) {
        searchAppLink = currentValue;
        this.props.getAppImage({ link: fields[name].value });
      }
      if (fields[platformsRadioName].value === 'ADJUST') {
        if (name === trackingLinkURLFieldName && (fields[name].value === 'http://' || fields[name].value === 'https://')) {
          fields[name].status = TEXT_FIELD_STATUS.VALID;
          fields[name].errorText = '';
        }
      }
    }
    this.setState(() => ({ searchAppLink, fields, formStatus }));
  };

  showDeleteModal = () => {
    this.setState(() => ({
      showDeleteModal: true,
    }));
  }
  hideDeleteModal = () => {
    this.setState(() => ({
      showDeleteModal: false,
    }));
  }

  submitHandler = (e) => {
    e.preventDefault();
    const fields = {
      ...this.state.fields,
    };
    Object
      .keys(this.fields)
      .forEach((name) => {
        if (!fields[name].outerError) {
          const { validator } = this.fields[name];
          const validate = validator(fields[name].value);
          fields[name].status = validate.status;
          fields[name].errorText = validate.errorText;
        }
        if (fields[platformsRadioName].value === 'ADJUST') {
          if (name === trackingLinkURLFieldName && (fields[name].value === 'http://' || fields[name].value === 'https://')) {
            fields[name].status = TEXT_FIELD_STATUS.VALID;
            fields[name].errorText = '';
          }
        } else if (name === trackingLinkURLFieldName) {
          fields[name].status = TEXT_FIELD_STATUS.VALID;
          fields[name].errorText = '';
        }
      });

    const formStatus = this.getFormStatus(fields);
    this.setState(() => ({ fields, formStatus }), () => {
      const { currentApp } = this.props;
      if (formStatus === TEXT_FIELD_STATUS.VALID) {
        const data = {};
        if (!currentApp.id) {
          data.link = fields[appLinkURLFieldName].value;
        }

        data.name = fields[appNameTextFieldName].value;
        const isImageLink = typeof fields[appImageInputName].value === 'string';
        if (isImageLink) {
          data.logoLink = fields[appImageInputName].value;
        } else {
          data.logo = fields[appImageInputName].value;
        }
        data.tracker = fields[platformsRadioName].value;
        if (fields[platformsRadioName].value === 'ADJUST') {
          if (fields[trackingLinkURLFieldName].value !== 'http://' && fields[trackingLinkURLFieldName].value !== 'https://') {
            data.trackingLink = fields[trackingLinkURLFieldName].value;
          }
        } else {
          data.trackingLink = 'https://appsfyler.null';
        }
        const { value: answersValue } = fields[appAnswersName];
        const answersKeys = Object.keys(answersValue);
        for (let i = 0; i < answersKeys.length; i += 1) {
          data[`answers[${answersKeys[i]}]`] = answersValue[answersKeys[i]];
        }
        if (currentApp.id) {
          this.props.updateApp({ data, appId: currentApp.id });
        } else {
          this.props.createApp(data);
        }
      }
    });
  }

  handlerDeleteApp = (id) => {
    const { deleteApplication } = this.props;
    deleteApplication(id);
  }

  renderModalFooter = () => {
    const { currentApp } = this.props;
    return (
      <React.Fragment>
        <Button label="Delete" clickHandler={() => this.handlerDeleteApp(currentApp.id)} />
        <Button label="Cancel" secondary clickHandler={this.hideDeleteModal} />
      </React.Fragment>
    );
  }

  renderModal = (visible) => {
    const { currentApp } = this.props;
    return (
      <InfoModal visible={visible} footer={this.renderModalFooter()}>
        <div className="modal-header">
          <span>
          Delete an app
          </span>
          <div className="modal-body">
            <span>{currentApp.name}{' '}
             app
            will be removed from
            all attached campaigns
            and cannot be restored
            </span>
          </div>
        </div>
      </InfoModal>
    );
  };

  render() {
    const {
      annulError,
      appImageStatus,
      getAppQuestions,
      appQuestions,
      createAppError,
      createAppStatus,
      currentApp,
      deleteAppError,
      deleteAppStatus,
      isAdmin,
      deleteAppSuccess,
    } = this.props;
    if (deleteAppSuccess) {
      return annulError;
    }
    const { formStatus, fields, showDeleteModal } = this.state;
    const disabledButton = formStatus === TEXT_FIELD_STATUS.INVALID;
    const appLinkURLField = fields[appLinkURLFieldName];
    const appNameField = fields[appNameTextFieldName];
    const appImageField = fields[appImageInputName];
    const platformRadio = fields[platformsRadioName];
    const targetToggle = fields[targetToggleName];
    const trackingLinkURLField = fields[trackingLinkURLFieldName];
    const appAnswers = fields[appAnswersName];
    const appImageLoading = appImageStatus === LOADING;
    const disabledEditApp = appImageStatus !== SUCCESS && !currentApp.id;
    const isCreateLoading = createAppStatus === LOADING || deleteAppStatus === LOADING;
    const isCreateError = createAppStatus === ERROR || deleteAppStatus === ERROR;
    const isSuccess = deleteAppStatus === SUCCESS || deleteAppStatus === SUCCESS;
    const radioGroupWrapperClasses = classNames({
      'form-radio-group-wrapper': true,
      'show-tooltip': platformRadio.value,
      'show-value': currentApp.id,
    });
    return (
      <div className="create-app-form-wrapper">
        {this.renderModal(showDeleteModal)}
        <form className="create-app-form">
          <LoadingOverlay visible={isCreateLoading} />
          <SuccessModal
            text={isSuccess}
            buttonClick={annulError}
            visible={isSuccess}
          />
          <ErrorModal
            requestClose={annulError}
            visible={isCreateError}
            error={createAppError || deleteAppError}
          />
          <CreateAppFormContext.Provider
            value={{
            register: this.registerField,
            changeHandler: this.fieldChangeHandler,
            focusHandler: this.fieldFocusHandler,
          }}
          >
            <div className="first-section">
              <div className="fields-wrapper">
                <div className="app-link-wrapper">
                  <URLTextField
                    name={appLinkURLFieldName}
                    value={appLinkURLField.value}
                    status={appLinkURLField.status}
                    isFocused={appLinkURLField.isFocused}
                    errorText={appLinkURLField.errorText}
                    isRequired
                    disabled={appLinkURLField.disabled || isAdmin}
                    className="app-link"
                    label="Link to the app"
                    placeholder="Link to the app"
                    needSpecifiedValidator
                    contextProvider={CONTEXT_PROVIDERS.CreateAppFormContext}
                    /* eslint-disable-next-line */
                    hint={(<span> Example: <a target="_blank" href={linkExample}>{linkExample}</a> </span>)}
                  />
                  {currentApp.id && <CopyValue iconOnly value={appLinkURLField.value} />}
                </div>
                <ToolTipWrapper
                  isActive={disabledEditApp}
                  event="click"
                  content="Please fill the App link at first"
                >
                  <ConnectedTextField
                    name={appNameTextFieldName}
                    value={appNameField.value}
                    status={appNameField.status}
                    isFocused={appNameField.isFocused}
                    errorText={appNameField.errorText}
                    hint={appNameField.hint}
                    isRequired
                    label="Application name"
                    placeholder="Application name"
                    errorSign
                    disabledView={disabledEditApp}
                    disabled={isAdmin}
                    contextProvider={CONTEXT_PROVIDERS.CreateAppFormContext}
                  />
                </ToolTipWrapper >
              </div>

              <ImageInput
                loading={appImageLoading}
                disabled={disabledEditApp || isAdmin}
                registerField={this.registerField}
                changeHandler={this.fieldChangeHandler}
                value={appImageField.value}
                name={appImageInputName}

              />
            </div>
            <div className={radioGroupWrapperClasses}>


              <RadioButtonGroup
                value={platformRadio.value}
                registerField={this.registerField}
                changeHandler={this.fieldChangeHandler}
                errorText={platformRadio.errorText}
                status={platformRadio.status}
                name={platformsRadioName}
                viewSelected={isAdmin || currentApp.id}
                isRequired
                header="Tracking platform"
                values={['ADJUST', 'APPSFLYER']}
              >

                <div className="img-wrapper">
                  <img src={adjustLogo} alt="adjust logo" />
                </div>


                <div className="img-wrapper">
                  <img src={appsflyerLogo} alt="appsflyer logo" />
                </div>

              </RadioButtonGroup>
              {!isAdmin &&
              <div className="side-tooltip-wrapper">
                <span className="side-tooltip">{platformRadio.value ? platformToolTips[platformRadio.value] : null}</span>
              </div>}
            </div>
            <div className="tracking-field-wrapper" style={{ display: platformRadio.value === 'ADJUST' ? 'block' : 'none' }}>
              <URLTextField
                name={trackingLinkURLFieldName}
                value={trackingLinkURLField.value}
                status={trackingLinkURLField.status}
                isFocused={trackingLinkURLField.isFocused}
                errorText={trackingLinkURLField.errorText}
                hint={trackingLinkURLField.hint}
                disabled={isAdmin || currentApp.id}
                label="Tracker Token"
                placeholder="Tracker Token"
                contextProvider={CONTEXT_PROVIDERS.CreateAppFormContext}
              />
              {currentApp && currentApp.id === undefined &&
              <ToolTipWrapper
                isActive={platformRadio.value === 'ADJUST'}
                content={
                  <p align="center">
                    Enter the link tracker token, for example: <br />
                    <strong>https://app.adjust.com/abc123</strong>
                  </p>
                }
              >
                <div className="tracker-field-info">
                  <img src={informLogo} alt="Information" />
                </div>
              </ToolTipWrapper>
              }
              {/* {currentApp.id && <CopyValue iconOnly value={trackingLinkURLField.value} />} */}
            </div>
            {isAdmin ?
              (Object.keys(appAnswers.value).length !== 0 && <div className="target-header"><span>Target Audience</span></div>)
            :
              <CheckBoxGroup
                value={targetToggle.value}
                registerField={this.registerField}
                changeHandler={this.fieldChangeHandler}
                errorText={targetToggle.errorText}
                status={targetToggle.status}
                name={targetToggleName}
                values={['audience']}
              >
                <div>
                  <span>Target Audience (optional)</span>
                </div>
              </CheckBoxGroup>
            }
            <Questions
              name={appAnswersName}
              registerField={this.registerField}
              value={appAnswers.value}
              changeHandler={this.fieldChangeHandler}
              isVisible={targetToggle.value.length}
              getAppQuestions={getAppQuestions}
              appQuestions={appQuestions}
              disabled={isAdmin}
              appAnswers={currentApp.answers}
            />
          </CreateAppFormContext.Provider>
          {!isAdmin &&
          <div className="button-wrapper">
            <Button
              disabled={disabledButton}
              label={currentApp.id ? 'Save' : 'Next'}
              clickHandler={this.submitHandler}
            />
          </div>
          }

        </form>
        {currentApp.id && isAdmin && <div className="button-wrapper" style={{ marginRight: '20%' }} ><Button clickHandler={this.showDeleteModal} label="Delete app" secondary /></div> }
      </div>
    );
  }
}

export default CreateAppForm;



// WEBPACK FOOTER //
// ./src/containers/CreateApp/components/Form/Form.js